<template>
  <li class="webhook-job d-flex mb-10">
    <div class="webhook-item__decoration position-relative d-flex justify-content-center pr-4 pr-lg-8">
      <div class="webhook-job__line bg-gray-300 mx-auto top-4 bottom-0 position-absolute" />
      <div
        class="webhook-item__pointer label label-dot top-4 position-relative label-xl bg-gray-600" />
    </div>
    <div class="webhook-item__content flex-grow-1 pt-2">
      <div class="font-weight-bolder font-size-lg mb-1">
        {{ webhookJobTitle(job.type) }}
      </div>
      <div class="font-weight-bold text-muted font-size-sm">
        {{ job.time | moment("DD.MM.YYYY, HH:mm") }}
        <span class="label label-dot bg-gray-500 label-sm mx-1"></span>
        {{ job.time | timeAgo }}
      </div>
      <template v-if="job.try > 0">
        <div class="d-flex mt-4">
          <div
            class="bullet bullet-bar bg-gray-200 rounded mr-3"
            style="width: 4px;" />
          <div>
            <div class="font-size-xs text-danger mb-1">
              <i class="fa fa-sync fa-xs mr-1 text-danger"></i>
              {{ job.try }}
              <span class="font-weight-bold">{{ 'attempt' | pluralize(job.try) }}</span>
            </div>
            <p class="font-size-sm font-weight-bold text-dark-50 mb-0">
              {{ job.last_error }}
            </p>
          </div>
        </div>
      </template>
      <b-button
        v-if="jobHasData"
        v-wave
        size="sm"
        variant="light"
        class="ml-auto mt-4"
        @click="showModal(`jobDetails-${job.time}`)">
        View details
      </b-button>
    </div>

    <b-modal
      v-if="jobHasData"
      :ref="`jobDetails-${job.time}`"
      centered
      size="lg"
      title="Webhook message data"
      footer-bg-variant=""
      body-class="p-0"
      hide-footer
      scrollable>
      <terminal
        :history="job.data"
        :embed="true" />
    </b-modal>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { showModal } from '@/core/utils'
import { timeAgo } from '@/core/filters'
import Terminal from '@/view/content/Terminal.vue'

export default {
  name: 'WebhookJobItem',
  components: {
    Terminal
  },
  filters: {
    timeAgo
  },
  props: {
    job: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      showModal,
    }
  },
  computed: {
    ...mapGetters([
      'integrationsList',
      'failedGetResellerStatus',
      'failedIntegrationGetStatus',
      'webhookUrl',
      'webhookUrlLength',
      'webhookUrlEmpty',
      'webhookUrlErrors',
      'webhookUrlError',
      'webhookJobsCount',
      'webhookJobs',
      'webhookIsEnabled',
      'webhookApiKey',
      'webhookApiKeyExist',
      'webhookIpLimitsLength',
      'webhookIpLimitsEmpty',
      'webhookIpLimitsChanged',
      'webhookIpLimitsSnapshot',
      'webhookJobsVocabulary',
      'webhookJobTitle',
      'webhookResponses'
    ]),

    jobHasData() {
      return Object.keys(this.job.data).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>

.webhook-job {
  position: relative;
	list-style-type: none;

	&__line {
    width: 1px;
		left: 5px; // based on label size;
    height: calc(100% + 4rem);
	}

	&:last-child {
    margin-bottom: 0 !important;
		.webhook-job__line {
			height: 50%;
      background-color: #fff !important;
		}
	}
}

</style>
